export const getLargestImageUrl = (formats: any) => {
  return formats?.large?.url || formats?.medium?.url || formats?.small?.url || formats?.thumbnail?.url || ''
}

export const getCloudinaryImageUrl = (url: string, params: string) => {
  const parts = url.split('/upload/')
  if (parts.length === 2) {
    return `${parts[0]}/upload/${params}/${parts[1]}`
  }
  return url
}
